export enum ThemeFileType {
	BACKGROUND = 'BACKGROUND',
	DARK_BACKGROUND = 'DARKBACKGROUND',
	LOGO = 'LOGO',
}

export enum AllowedImageType {
	PNG = 'image/png',
	JPEG = 'image/jpeg',
	GIF = 'image/gif',
}

export enum ThemeErrorType {
	VALIDATION_ERROR = 'VALIDATION_ERROR',
}

export type ThemeFileMetadata = {
	id: string;
	s3Etag: string;
	size: number;
	themeFileType: ThemeFileType;
};

export type GetThemeFileMetadataResponse = ThemeFileMetadata[];

export type GetThemeFileResponse = {
	url?: string;
};

export type UploadThemeImageResponse = {
	success: boolean;
} & ThemeFileMetadata;

export type UpdateThemeImageResponse = {
	success: boolean;
} & ThemeFileMetadata;
